var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"form"},[_c('div',{staticClass:"fullText"},[_vm._v(_vm._s(_vm.desc))])]),_c('app-actions',{on:{"nextStep":_vm.nextStep}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }